import i18n from "@/i18n/index.ts";
export default class DataOptions {
}
DataOptions.Breadcrumbs = [
    {
        to: "/",
        text: i18n.t("breadcrumbs.home"),
    },
    {
        to: "/shop/discount-codes",
        text: i18n.t("breadcrumbs.discount_codes"),
        disabled: true,
    },
];
DataOptions.BreadcrumbsCreate = [
    {
        to: "/",
        text: i18n.t("breadcrumbs.home"),
    },
    {
        to: "/shop/discount-codes",
        exact: true,
        text: i18n.t("breadcrumbs.discount_codes"),
    },
    {
        text: i18n.t("breadcrumbs.create"),
        disabled: true,
    },
];
DataOptions.BreadcrumbsEdit = [
    {
        to: "/",
        text: i18n.t("breadcrumbs.home"),
    },
    {
        to: "/shop/discount-codes",
        exact: true,
        text: i18n.t("breadcrumbs.discount_codes"),
    },
    {
        text: i18n.t("breadcrumbs.edit"),
        disabled: true,
    },
];
DataOptions.TableHeaders = [
    {
        text: "Name",
        value: "name",
        width: "25%",
    },
    {
        text: "Validity",
        value: "expires_at",
        width: "25%",
    },
    {
        text: "Status",
        value: "active",
        width: "25%",
    },
    {
        text: "Creation date",
        value: "created_at",
        width: "25%",
    },
    {
        text: i18n.t("table_headers.action"),
        value: "action",
    },
];
